import { AttachmentsUploaderContextProvider } from '@components'

import { ModalProps, withModalConditionalRender } from '@billy/design-system'
import { useMemo } from 'react'

import { Contact } from '@features/contacts/types/contact'
import { SendAsEInvoiceForm } from '@features/invoices/types/sendAsEInvoiceForm'
import { getUploadAttachmentSessionUrl } from '@features/invoices/utils/getUploadAttachmentSessionUrl'

import type { PredefinedCustomerValues } from '../../types/predefinedCustomerValues'
import { EInvoicingAddressFormContextProvider } from './contexts/eInvoicingAddressFormContext'
import { SendAsEInvoiceModalComponent } from './elements/SendAsEInvoiceModalComponent'
import type { SendAsEInvoiceModalView } from './types/sendAsEInvoiceModalView'

interface SendAsEInvoiceProps extends ModalProps {
  attachmentsEnabled?: boolean
  isMissingCustomerEInvoicingAddress: boolean
  isSubmitting: boolean
  onBeforeSubmit?: () => void
  onCustomerUpdated?: (customer: Contact) => void
  onSubmit: (formData: SendAsEInvoiceForm) => void
  predefinedCustomerValues?: PredefinedCustomerValues
  view: SendAsEInvoiceModalView
}

const SendAsEInvoice = ({
  attachmentsEnabled = true,
  isMissingCustomerEInvoicingAddress,
  isSubmitting,
  onBeforeSubmit,
  onCustomerUpdated,
  onSubmit,
  predefinedCustomerValues,
  view,
  ...modalProps
}: SendAsEInvoiceProps) => {
  const { sessionId, url: uploadAttachmentUrl } = useMemo(() => getUploadAttachmentSessionUrl(), [])

  return (
    <AttachmentsUploaderContextProvider sessionId={sessionId} url={uploadAttachmentUrl}>
      <EInvoicingAddressFormContextProvider
        isSubmitting={isSubmitting}
        modalId={modalProps.id}
        onCustomerUpdated={onCustomerUpdated}
        onSubmit={onSubmit}
        predefinedCustomerValues={predefinedCustomerValues}
      >
        <SendAsEInvoiceModalComponent
          {...modalProps}
          attachmentsEnabled={attachmentsEnabled}
          isMissingCustomerEInvoicingAddress={isMissingCustomerEInvoicingAddress}
          onBeforeSubmit={onBeforeSubmit}
          view={view}
        />
      </EInvoicingAddressFormContextProvider>
    </AttachmentsUploaderContextProvider>
  )
}

export const SendAsEInvoiceModal = withModalConditionalRender(SendAsEInvoice)
